<template>
  <!-- el-alert renders role="alert"; its default slot is a <p>: phrasing content only. -->
  <el-alert
    class="import-error-alert"
    :type="type"
    :closable="false"
    show-icon
  >
    <span
      ref="title"
      slot="title"
      tabindex="-1"
    >
      {{ title }}
    </span>
    <span
      v-for="line in lines"
      :key="line.key"
      class="import-error-alert__line"
    >
      <i
        :class="line.icon"
        aria-hidden="true"
      />
      {{ line.text }}
    </span>
    <span
      v-if="$slots.actions"
      class="import-error-alert__actions"
    >
      <slot name="actions" />
    </span>
  </el-alert>
</template>

<script>
  // Summary of what to fix in the file: a title, one line per cause, the
  // actions last. An error takes the focus when shown (REQ-22), so the parent
  // re-mounts it for every new error; a warning that does not stop the import
  // leaves the focus where it is (C53).
  export default {
    name: 'ImportErrorAlert',
    props: {
      title: { type: String, required: true },
      // [{ key, icon, text }]
      lines: { type: Array, default: () => [] },
      type: {
        type: String,
        default: 'error',
        validator: (value) => ['error', 'warning'].includes(value),
      },
      focusOnMount: { type: Boolean, default: true },
    },
    mounted() {
      if (this.focusOnMount) this.$refs.title.focus();
    },
  };
</script>

<style lang="scss" scoped>
  // el-alert centres its icon on the whole block and packs title,
  // description and actions at 12-13px with no rhythm: the icon stays on the
  // title line and each part gets its own space.
  .import-error-alert {
    align-items: flex-start;
    padding: 1rem 1.25rem;

    ::v-deep .el-alert__title {
      font-size: 1rem;
      line-height: 1.5;
    }

    ::v-deep .el-alert__description {
      margin-top: 0.5rem;
      font-size: 0.875rem;
      line-height: 1.6;
    }
  }

  .import-error-alert__line {
    display: block;

    i {
      margin-right: 0.375rem;
    }
  }

  .import-error-alert__actions {
    display: block;
    margin-top: 0.75rem;
  }
</style>
